import { useRef } from "react";
import classes from "./StoreData.module.css";
import { useContext } from "react";
import { CartContext } from "../../CartContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StoreData = (props) => {
  const cart = useContext(CartContext);

  const sizeRef = useRef();
  const { product } = props;

  console.log(product.price);
  const productQuantity = cart.getProductQuantity(product.id);
  const price = new Intl.NumberFormat().format(product.prevPrice);
  const promoPrice = new Intl.NumberFormat().format(product.price);

  const addCartHandler = () => {
    cart.addOneToCart(product.id);
    toast.success("One item added to cart", {
      position: "top-center",
      autoClose: 500,
    });
  };
  const removeCartHandler = () => {
    cart.removeOneFromCart(product.id);
    toast.success("One item removed from cart", {
      position: "top-center",
      autoClose: 500,
    });
  };
  const deleteCartHandler = () => {
    cart.deleteFromCart(product.id);
    toast.warning("Cart item deleted", {
      position: "top-center",
      autoClose: 500,
    });
  };

  return (
    <li className={classes.list}>
      {
        <div className={classes.image}>
          <img alt={product.name} src={product.image} />
          {product.soldOut && <h1 className="soldout">Sold Out!</h1>}
        </div>
      }

      <div className={classes.content}>
        {<h1>{product.name}</h1>}
        {<p>{product.description}</p>}
        {<p>Sizes: {product.size}</p>}
        {
          <div className={classes.select}>
            <label>Select Size</label>
            <select ref={sizeRef} htmlFor="size">
              <option value="small">S</option>
              <option value="medium">M</option>
              <option value="large">L</option>
              <option value="extra large">XL</option>
              <option value="extra extra large">2XL</option>
            </select>
          </div>
        }
        <hr />
        {<h2>Price: N{promoPrice}</h2>}
        {<s>Price: N{price}</s>}
        {productQuantity > 0 ? (
          <div className={classes.actions}>
            <button onClick={addCartHandler}>+</button>
            <button onClick={removeCartHandler}>-</button>
          </div>
        ) : (
          <button disabled={product.soldOut} onClick={addCartHandler}>
            {product.soldOut ? "SOLD OUT!" : " Add To Cart"}
          </button>
        )}
        {productQuantity > 0 && (
          <button onClick={deleteCartHandler}>Remove From cart</button>
        )}
      </div>
      <ToastContainer position="top-center" autoClose={1000} />
    </li>
  );
};

export default StoreData;
